import React from "react";
import Modal from "common/components/Modal";
import Input from "common/components/Input";
import { Stack } from "@mui/material";
import SectionHeader from "common/components/SectionHeader";
import ActionButton from "common/components/ActionButton";
import toast from "react-hot-toast";
import useFetcher from "common/hooks/useFetcher";
const NewFile = ({ handleClose, refresh, system }) => {
  const fetcher = useFetcher();
  const [name, setName] = React.useState("");
  const createSheet = async () => {
    if (!name) return toast.error("Must provide a name for the new sheet");
    await fetcher.post(
      "creating sheet",
      `/api/sys/${system}/sheet`,
      () => {
        let form = new FormData();
        form.append("json", JSON.stringify({ name }));
        return form;
      },
      ({ error }) => {
        if (error) {
          toast.error(error);
          setLoading(false);
          return;
        }
        toast.success("sheet created");
        refresh();
        handleClose();
      },
      ({ error }) => {}
    );
  };
  return (
    <Stack gap={3}>
      <Stack
        direction="row"
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <SectionHeader>New Sheet</SectionHeader>
      </Stack>

      <Input
        size="small"
        sx={{ width: "100%" }}
        label="Name"
        autoFocus
        placeholder="mysheet"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <div style={{ marginLeft: "auto" }}>
        <ActionButton icon={"save"} handler={createSheet}>
          Save
        </ActionButton>
      </div>
    </Stack>
  );
};

export default function NewFileModal({ open, setOpen, refresh, system }) {
  return (
    <Modal
      width={500}
      forceOpen={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      {({ handleClose }) => (
        <NewFile handleClose={handleClose} refresh={refresh} system={system} />
      )}
    </Modal>
  );
}
